// @flow

import publicApiService from './public-api-service';
import authApiService from './auth-api-service';

/* eslint-disable */
class ShareService {
  getSharedRecords(id: Number) {
    return authApiService
      .get(`/health_records/${id}/share`)
      .then((response) => response.viewers);
  }

  getAllShares() {
    return authApiService
      .get('/resources/share/sent?exclude=nested')
      .then((response) => response.viewers);
  }

  getSharedRecord(token: string) {
    return publicApiService
      .get(`/public/shared/${token}`)
      .then((response) => response.viewer);
  }

  getSharedRecordDetails(token: string, accessToken: string) {
    return publicApiService
      .get(`/public/shared/${token}/record`,
        { headers: {
          Authorization: `Bearer ${accessToken}` } })
      .then((response) => response.record);
  }

  getThumbnail(token: string, id: Number, accessToken: string) {
    return publicApiService
      .get(`/public/shared/${token}/file/${id}/thumb`,
        { responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${accessToken}` } })
      .then((response) =>
        new Blob([response], { type: response.type })
      );
  }

  getFile(token: string, id: Number, accessToken: string) {
    return publicApiService
      .get(`/public/shared/${token}/file/${id}`,
        { headers: {
          'Authorization': `Bearer ${accessToken}` } })
      .then((response) => response.file);
  }

  viewFile(token: string, id: Number, accessToken: string) {
    return publicApiService
      .get(`/public/shared/${token}/file/${id}/view`,
        { responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${accessToken}` } })
      .then((response) =>
        new Blob([response], { type: response.type })
      );
  }

  share(id: Number, shareInfo: Object) {
    return authApiService
      .post(`/resources/${id}/share`,
        { viewer: { 
            emails: shareInfo.emails,
            expiry_date: shareInfo.expiry_date
          }
        })
      .then((response) => response);
  }

  shareMultiple(shareInfo: Object) {
    return authApiService
      .post(`/resources/share`,
        { viewer: {
            emails: shareInfo.emails,
            email_keys: shareInfo.email_keys,
            resource_ids: shareInfo.resource_ids,
            expiry_date: shareInfo.expiry_date
          }
        })
      .then((response) => response);
  }

  revoke(id: Number, revoked: Object) {
    return authApiService
      .put(`/resources/share/${id}`,
        { viewer: revoked });
  }

  verifyPassword(token: string, password: string) {
    return publicApiService
      .post(`/public/shared/${token}`,
        { viewer: { password: password } })
      .then((response) => response);
  }

  delete(id: Number) {
    return authApiService
      .delete(`/resources/share/${id}`)
      .then((response) => response);
  }
}

/* eslint-enable */

export default new ShareService();



// WEBPACK FOOTER //
// ./src/services/record-sharing-service.js